import type { ValidationDefinition, ValidationResult } from './types';

export const validate = <InputValueType>(
  currentValue: InputValueType,
  validation: ValidationDefinition<InputValueType>,
): ValidationResult => {
  const { validators } = validation;
  for (let i = 0; i < validators.length; i++) {
    const validator = validators[i];
    const validatorResult = validator?.validator(currentValue);
    if (!validatorResult) {
      return {
        valid: false,
        classNames: validator?.invalidClassName,
        message: validator?.invalidErrorMessage,
      };
    }
  }

  return {
    valid: true,
    classNames: validation.successClassName,
  };
};
